import React, { useMemo, useEffect, useState } from 'react';
import AdTable from './components/AdsTable.js';
import { useTableState } from './utils/useTableState.js';
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_page",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
  {
    value:"promoted_video_story",
    label:"Promoted Video Story"
  },
  {
    value: "classifiedads",
    label: "Classified Ads"
  }
]
const STATUS_OPTIONS = [
  { value: 2, label: 'Saved' },
  { value: 3, label: 'Picked' },
  { value: 4, label: 'Completed' },
  { value: 5, label: 'Rejected' },
  { value: 6, label: 'Accepted' },
];

const AllAds = ({ isActive }) => {
    const allAdsColumns = [
        { key: "sales_person", label: "Sales Person Details" },
        { key: "cst_name", label: "CST Name" },
        { key: "designer_name", label: "Designer Name" },
        { key: "created_at", label: "Ad Creation Date" },
        // { key: "brand_name", label: "Brand" },
        // { key: "client_name", label: "Client" },
        { key: "creative_name", label: "Campaign Name" },
        // { key: "creative_start_date", label: "Start Date" },
        // { key: "creative_end_date", label: "End Date" },
        { key: "ad_creative_sub_type", label: "Ad Type" },
        // { key: "type", label: "Creative Type" },
        { key: "client_mobile", label: "Mobile" },
        { key: "content", label:"Content"},
        { key: "status", label: "Design Status" },
        { key: "live_status", label: "Live" },
        { key: "action", label: "Action" },
    ];
    const {
        fetchAllAds,
        currentPage,
        adsData,
        setCurrentPage,
        designers,
        fetchDesigners,
        loading,
        totalPages,
        showActionsMenu,
        modal,
        drawer,
        expandedVersionsRow,
        actionHandlers,
        renderCell,
        getModalAlt,
        closeExpandedRows,
        handleDesignerChange,
        handlePageClick,
        handleGoToLive,
        fetchContent
    } = useTableState();

    const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
    const [designer, setDesigner] = useState(null);
    const [status, setStatus] = useState(null);
    const [adType, setAdType] = useState(null);
    const [search, setSearch] = useState('');

    const designerOptions = useMemo(() =>
        designers.map(d => ({ value: d.designer_id, label: d.name })),
        [designers]
    );

    useEffect(() => {
        fetchDesigners();
    }, []);

    useEffect(() => {
        fetchAllAds(currentPage, isActive, {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            designerId: designer ? designer.value : undefined,
            status: status ? status.value : undefined,
            adType: adType && adType.value !== 'all' ? adType.value : undefined,
            search: search || undefined,
        });
    }, [isActive, currentPage, dateRange, designer, status, adType, search]);

    const handleDateChange = (val) => setDateRange(val);
    const handleDesignerChangeSelect = (val) => setDesigner(val);
    const handleStatusChange = (val) => setStatus(val);
    const handleAdTypeChange = (val) => setAdType(val);
    const handleSearchChange = (e) => setSearch(e.target.value);

    const processedData = useMemo(() => {
        return adsData.map(ad => ({
            ...ad,
            live_status: ad.paymentStatus === 'Done' ? 'Live' : 'Pending'
        }));
    }, [adsData]);

    return (
        <div>
            <div className="flex flex-wrap gap-4 mb-4 items-end">
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Start Date Range</label>
                    <div className='border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66'>
                        <Datepicker
                            value={dateRange}
                            onChange={handleDateChange}
                            primaryColor="cyan"
                            showShortcuts={true}
                            classNames="form-input"
                            asSingle={false}
                        />
                    </div>
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Search</label>
                    <input
                        type="text"
                        className="w-full border rounded px-2 py-1"
                        placeholder="Search by campaign/brand/client"
                        value={search}
                        onChange={handleSearchChange}
                    />
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Ad Type</label>
                    <Select
                        options={types}
                        value={adType}
                        onChange={handleAdTypeChange}
                        isClearable
                        placeholder="Select Ad Type"
                        classNamePrefix="react-select"
                    />
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Designer</label>
                    <Select
                        options={designerOptions}
                        value={designer}
                        onChange={handleDesignerChangeSelect}
                        isClearable
                        placeholder="Select Designer"
                        classNamePrefix="react-select"
                    />
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Design Status</label>
                    <Select
                        options={STATUS_OPTIONS}
                        value={status}
                        onChange={handleStatusChange}
                        isClearable
                        placeholder="Select Status"
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
            <div>
                <AdTable
                    data={processedData}
                    columns={allAdsColumns}
                    loading={loading}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageClick={handlePageClick}
                    designers={designers}
                    showActionsMenu={showActionsMenu}
                    modal={modal}
                    drawer={drawer}
                    expandedVersionsRow={expandedVersionsRow}
                    actionHandlers={actionHandlers}
                    renderCell={renderCell}
                    getModalAlt={getModalAlt}
                    closeExpandedRows={closeExpandedRows}
                    handleDesignerChange={handleDesignerChange}
                    handleGoToLive={handleGoToLive}
                    fetchContent={fetchContent}
                />
            </div>
        </div>
    );
};

export default AllAds;